"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.add0x = exports.trim0x = void 0;
function trim0x(data) {
    if (data.startsWith('0x')) {
        return data.substring(2);
    }
    return data;
}
exports.trim0x = trim0x;
function add0x(data) {
    if (data.includes('0x')) {
        return data;
    }
    return '0x' + data;
}
exports.add0x = add0x;
//# sourceMappingURL=zero-x-prefix.js.map